var _defs, _path, _path2, _polygon, _path3, _path4, _polygon2, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFauteTechniqueBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e05b37;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #4970b6;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.61px;\n      }\n\n      .cls-2 {\n        fill: #df5c37;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.62,62.81l49.32-27.01s19.98-13.34,30.36,4.83l10.23,14.13,2.65,3.66s10.13,19.14-13.14,30.61c0,0-16.4,10.14-27.03-7.06,0,0-3.68-8.41-16.02-3.15l-22.44,9.61-6.96-6.28-6.98-19.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.53,54.76s-7.71-7.98-25.38.47l-57.55,26.93"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "63.07 48.77 67.49 46.64 75 58.44 70.04 60.73 63.07 48.77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.6,81.59s-5.37-10.04,6.51-18.02c0,0,14.97-11.43,21.17-.15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.56,42.37c1.55-1.4,3.76-2.02,5.94-1.46,3.43.9,5.49,4.41,4.6,7.84-.45,1.71-1.55,3.09-2.97,3.92"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.07 35.95 63.07 8.01 53.07 8.01 63.07 35.95"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "57.63 38.63 52.53 27.39 48.51 29.22 57.63 38.63"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFauteTechniqueBasket);
export default __webpack_public_path__ + "static/media/faute_technique_basket.db73369559d4398d134d35ce7dbddcd3.svg";
export { ForwardRef as ReactComponent };